// Vendors
import { useLayoutEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { MessageFormatElement } from 'react-intl';
// Contexts
import { useAppInformationContextConsumerHook } from 'contexts/app-information.context';
// Event Handlers
import InternationalizationHandlers from '../handlers/internationalization.handlers';
// Hooks
import {
  getLocaleFromQueryParam,
  getTranslationsFromStorage,
  getUserLanguage,
} from './utils/internationalization.hook.utils';
// Types
import { InternationalizationReturnHookType } from './types/internationalization-return.hook.type';

const useInternationalizationHook = (): InternationalizationReturnHookType => {
  const { showBoundary: setError } = useErrorBoundary();

  const locale = getUserLanguage({ languagePreference: getLocaleFromQueryParam() });

  const [fetching, setFetching] = useState<boolean>(false);
  const [translations, setTranslations] = useState(getTranslationsFromStorage());

  const { setInformationFlags } = useAppInformationContextConsumerHook();

  const { handleFetchTranslations } = InternationalizationHandlers({
    locale,
    setError,
    setTranslations,
    setFetching,
    setInformationFlags,
  });

  useLayoutEffect(() => {
    handleFetchTranslations();
  }, [locale]);

  return {
    fetching,
    locale,
    translations: translations as Record<string, MessageFormatElement[]>,
  };
};

export { useInternationalizationHook };
